import { render, staticRenderFns } from "./BrandPending.vue?vue&type=template&id=11bfc639&lang=pug"
import script from "./BrandPending.vue?vue&type=script&lang=js"
export * from "./BrandPending.vue?vue&type=script&lang=js"
import style0 from "./BrandPending.vue?vue&type=style&index=0&id=11bfc639&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports